import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FileText, Newspaper, Inbox, ArrowRight } from 'lucide-react';
import { api } from '../lib/api';

export default function Dashboard() {
  const [stats, setStats] = useState({ posts: 0, submissions: 0, unread: 0 });

  useEffect(() => {
    Promise.all([api.get('/posts?all=true'), api.get('/admin/submissions')])
      .then(([postsRes, subsRes]) => {
        setStats({
          posts: postsRes.data.length,
          submissions: subsRes.data.length,
          unread: subsRes.data.filter((s) => !s.read).length,
        });
      })
      .catch(() => {});
  }, []);

  const cards = [
    { label: 'Blog Posts', value: stats.posts, icon: Newspaper, to: '/admin/blog', color: '#2E8B57' },
    { label: 'Form Submissions', value: stats.submissions, icon: Inbox, to: '/admin/submissions', color: '#26247B' },
    { label: 'Unread Enquiries', value: stats.unread, icon: Inbox, to: '/admin/submissions', color: '#F4A300' },
  ];

  const quickLinks = [
    { label: 'Edit Homepage Hero Slider', to: '/admin/content/hero_slides' },
    { label: 'Edit About Us Page', to: '/admin/content/about_page' },
    { label: 'Manage News & Blog Posts', to: '/admin/blog' },
    { label: 'View Form Submissions', to: '/admin/submissions' },
    { label: 'Update reCAPTCHA / Site Settings', to: '/admin/settings' },
  ];

  return (
    <div data-testid="admin-dashboard">
      <h1 className="text-2xl font-extrabold text-[#26247B]">Dashboard</h1>
      <p className="mt-1 text-sm text-black/60">Welcome to the Intexso Biochem content management system.</p>

      <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-5">
        {cards.map((c) => (
          <Link key={c.label} to={c.to} className="bg-white rounded-2xl border border-[#E6E8EE] p-6 card-lift block">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-semibold text-black/60">{c.label}</p>
                <p className="mt-1 text-3xl font-extrabold" style={{ color: c.color }}>{c.value}</p>
              </div>
              <div className="h-12 w-12 rounded-xl flex items-center justify-center" style={{ background: `${c.color}18` }}>
                <c.icon className="h-6 w-6" style={{ color: c.color }} />
              </div>
            </div>
          </Link>
        ))}
      </div>

      <div className="mt-8 bg-white rounded-2xl border border-[#E6E8EE] p-6">
        <h2 className="font-extrabold text-[#26247B] flex items-center gap-2">
          <FileText className="h-5 w-5" /> Quick Actions
        </h2>
        <div className="mt-4 space-y-2">
          {quickLinks.map((l) => (
            <Link
              key={l.label}
              to={l.to}
              className="flex items-center justify-between px-4 py-3 rounded-lg bg-[#F6F7F9] hover:bg-[#eceef2] text-sm font-semibold text-[#26247B] transition-colors duration-200"
            >
              {l.label} <ArrowRight className="h-4 w-4" />
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
